// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-spin-custom,
.glyphicon-spin {
  -webkit-animation: spin 1000ms infinite linear;
  animation: spin 1000ms infinite linear;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.search {
  background: #071c35;
  padding: 5px 10px;
}
.search .row .col-md-12 {
  padding-left: 0;
  padding-right: 0;
}
.search .search-form .input-base {
  padding: 5px 7px;
  height: 2.5rem;
  text-align: left;
  display: block;
  outline-width: 0;
  color: #ffffff;
  background-color: #a8b0b8;
  border: 1px solid #ffffff;
}
.search .search-form select,
.search .search-form input {
  padding: 5px 7px;
  height: 2.5rem;
  text-align: left;
  display: block;
  outline-width: 0;
  color: #ffffff;
  background-color: #a8b0b8;
  border: 1px solid #ffffff;
}
.search .search-form input.hours-field,
.search .search-form input.minutes-field {
  text-align: center;
  min-width: 32px;
}
.search .search-form .waiver-selector select {
  display: block;
  outline-width: 0;
  height: 2.5rem;
}
.search .search-form input::-webkit-input-placeholder,
.search .search-form input:-moz-placeholder,
.search .search-form input::-moz-placeholder,
.search .search-form input:-ms-input-placeholder {
  color: #ffffff;
  font-style: italic;
}
.search .search-form label {
  margin-top: 10px;
  color: #ffffff;
}
.search .search-form .ng-invalid.ng-dirty {
  border-color: #c02323;
  outline-color: #c02323;
}
.search .search-form .ng-valid.ng-dirty {
  border-color: #006400;
  outline-color: #006400;
}
.search .search-form .form-group-sep {
  padding-top: 10px;
}
.search .search-form .input-group {
  margin-bottom: 0;
}
.search .search-form .search-button {
  text-align: right;
}
.search .search-form .search-button .form-group {
  margin: 25px 0 0 25px;
}
.search .search-form .search-button .form-group .button-clear,
.search .search-form .search-button .form-group .button-action {
  color: #ffffff;
  width: 125px;
  height: 30px;
  padding: 5px 35px;
  border: 1px solid;
}
.search .search-form .search-button .form-group .button-clear {
  background-color: #81a2ca;
  border-color: #81a2ca;
  margin-right: 10px;
}
.search .search-form .search-button .form-group .button-clear:hover {
  background-color: #4a709d;
  border-color: #4a709d;
}
.search .search-form .search-button .form-group .button-action {
  background-color: #faa718;
  border-color: #faa718;
}
.search .search-form .search-button .form-group .button-action:hover {
  background-color: #81a2ca;
  border-color: #81a2ca;
}
.search .search-form i.sprites.sprite-calendar-gray,
.search .search-form i.sprites.sprite-calendar-ivory {
  display: block;
  height: 20px;
}
.search .search-form div[uib-accordion],
.search .search-form div.uib-accordion {
  margin-top: 0;
  margin-bottom: 0;
}
.search .search-form div[uib-accordion] .panel-heading,
.search .search-form div.uib-accordion .panel-heading {
  background: #c1c7cd;
  padding: 15px;
  color: #071c35;
}
.search .search-form div[uib-accordion] .panel-heading .panel-title,
.search .search-form div.uib-accordion .panel-heading .panel-title {
  margin: 0;
  font-size: 14px;
}
.search .search-form div[uib-accordion] .panel-heading .panel-title i,
.search .search-form div.uib-accordion .panel-heading .panel-title i {
  margin-right: 0.2em;
}
.search .search-form div[uib-accordion] .panel-heading .panel-title a,
.search .search-form div.uib-accordion .panel-heading .panel-title a {
  color: #071c35;
  text-decoration: none;
}
.search .search-form div[uib-accordion] .panel-heading .panel-title a:hover,
.search .search-form div.uib-accordion .panel-heading .panel-title a:hover,
.search .search-form div[uib-accordion] .panel-heading .panel-title a:focus,
.search .search-form div.uib-accordion .panel-heading .panel-title a:focus {
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}
.search .search-form div[uib-accordion] .panel-group,
.search .search-form div.uib-accordion .panel-group {
  margin-bottom: 0;
}
.search .search-form div[uib-accordion] .panel-group .panel,
.search .search-form div.uib-accordion .panel-group .panel {
  border: 0;
  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
}
.search .search-form div[uib-accordion] .panel-group .panel-body,
.search .search-form div.uib-accordion .panel-group .panel-body {
  border-top: 0;
  background: #828e9a;
  padding: 0 5px 15px 5px;
}
.search .search-form .trip-group-selector {
  padding: 5px 7px;
  height: 2.5rem;
  text-align: left;
  display: block;
  outline-width: 0;
  color: #ffffff;
  background-color: #a8b0b8;
  border: 1px solid #ffffff;
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  height: 100px;
  overflow-y: auto;
}
.search .search-form .trip-group-selector:hover {
  cursor: pointer;
}
.search input[type='number']::-webkit-inner-spin-button,
.search input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.search .resolve-by {
  padding-left: 0;
}
.search .resolve-by.resolve-by-date-selectors {
  margin-bottom: 0.5rem;
}
.uib-datepicker-popup {
  color: #333;
}
.date-picker-label {
  display: block;
  font-weight: normal;
}
.date-picker-input {
  vertical-align: top;
  height: 2.5rem;
}
.date-picker-input .input-group-btn {
  vertical-align: top;
  margin-right: 20px;
}
.date-picker-input .input-group-btn button {
  vertical-align: top;
  height: 2.5rem;
  border-left: none;
  background-color: #a8b0b8;
  border-color: #ffffff;
}
.date-picker-input .input-group-btn button.ng-invalid.ng-dirty {
  border-left: 0;
  border-color: #c02323;
  outline-color: #c02323;
}
.date-picker-input .input-group-btn button .sprite-calendar-gray {
  display: block;
  height: 20px;
}
.timepicker {
  padding-left: 0;
  margin-right: 0;
  margin-bottom: -20px;
  margin-top: 15px;
}
.timepicker a {
  color: #f5f5f5;
  text-decoration: none;
}
.timepicker a:hover,
.timepicker a:focus {
  color: #faa718;
  text-decoration: none;
  cursor: pointer;
}
.timepicker td {
  padding-right: 5px;
}
.timepicker .timepicker-field input {
  width: 40px;
}
.timepicker .uib-time input {
  width: 40px;
}
.timepicker .btn {
  padding: 5px 10px;
}
.timepicker .btn-link {
  padding: 2px 0;
}
.search-title {
  background: #071c35;
}
.search-title .col-md-12 {
  padding: 10px 0 5px 10px;
  color: #ffffff;
}
.search-actions .actions {
  margin: 10px 0;
}
.search-actions .actions .btn {
  color: #071c35;
}
.search-actions .actions .btn:hover,
.search-actions .actions .btn:focus {
  color: #f5f5f5;
}
.month-select {
  padding-right: 0.1rem;
}
.flight-search-datepicker {
  display: inline;
}
.flight-search-datepicker .custom-date-picker-input input,
.flight-search-datepicker .custom-date-picker-input .form-control {
  background-color: #a8b0b8;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-right: 0;
  height: 2.5rem;
}
.flight-search-datepicker .custom-date-picker-input input::placeholder,
.flight-search-datepicker .custom-date-picker-input .form-control::placeholder {
  color: #ffffff;
  /* Change this to your desired placeholder color */
  opacity: 1;
  /* Ensure full opacity for the placeholder text */
}
.flight-search-datepicker .date-picker-wrapper {
  padding-left: 0;
  padding-right: 0;
}
.custom-date-picker-input input,
.custom-date-picker-input .form-control {
  border-right: 0 !important;
  box-shadow: none !important;
}
.time-picker-width {
  width: 3.125rem;
  height: 2.5rem;
}
.time-picker-width .btn {
  margin-left: 5px;
  height: 2.5rem;
}
.waiver-reporting-form-button {
  display: flex;
  justify-content: end;
}
.month-select__single-value,
.year-select__single-value {
  margin-bottom: 0.625rem;
}
.flight-search-datepicker .month-select__single-value,
.flight-search-datepicker .year-select__single-value {
  margin-bottom: 0;
}
.date-range-picker-input {
  background-color: #a8b0b8;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-right: 0;
  height: 2.5rem;
}
.date-range-picker-input::placeholder {
  color: #ffffff;
  /* Change this to your desired placeholder color */
  opacity: 1;
  /* Ensure full opacity for the placeholder text */
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/utility.less","webpack://./src/styles/modules/search.less"],"names":[],"mappings":"AAiGA;;EAEE,8CAAA;EACA,sCAAA;AChGF;ADkGA;EACE;IACE,+BAAA;IACA,uBAAA;EChGF;EDkGA;IACE,iCAAA;IACA,yBAAA;EChGF;AACF;ADkGA;EACE;IACE,+BAAA;IACA,uBAAA;EChGF;EDkGA;IACE,iCAAA;IACA,yBAAA;EChGF;AACF;AANA;EACE,mBAAA;EACA,iBAAA;AAQF;AAVA;EAMM,eAAA;EACA,gBAAA;AAON;AAdA;EAaM,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;AAIN;AAxBA;;EAaM,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;AAeN;AAnCA;;EA8BM,kBAAA;EACA,eAAA;AASN;AAxCA;EAmCM,cAAA;EACA,gBAAA;EACA,cAAA;AAQN;AA7CA;;;;EA4CM,cAAA;EACA,kBAAA;AAON;AApDA;EAiDM,gBAAA;EACA,cAAA;AAMN;AAxDA;EAsDM,qBAAA;EACA,sBAAA;AAKN;AA5DA;EA0DM,qBAAA;EACA,sBAAA;AAKN;AAhEA;EA+DM,iBAAA;AAIN;AAnEA;EAmEM,gBAAA;AAGN;AAtEA;EAuEM,iBAAA;AAEN;AAzEA;EA0EQ,qBAAA;AAER;AA5EA;;EA6EU,cAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAGV;AApFA;EAqFU,yBAAA;EACA,qBAAA;EACA,kBAAA;AAEV;AAzFA;EA0FU,yBAAA;EACA,qBAAA;AAEV;AA7FA;EA+FU,yBAAA;EACA,qBAAA;AACV;AAjGA;EAmGU,yBAAA;EACA,qBAAA;AACV;AArGA;;EA2GM,cAAA;EACA,YAAA;AAFN;AA1GA;;EAiHM,aAAA;EACA,gBAAA;AAHN;AA/GA;;EAqHQ,mBAAA;EACA,aAAA;EACA,cAAA;AAFR;AArHA;;EA0HU,SAAA;EACA,eAAA;AADV;AA1HA;;EA6HY,mBAAA;AACZ;AA9HA;;EDEI,cAAA;EACA,qBAAA;ACgIJ;AAnIA;;;;EDOI,cAAA;EACA,qBAAA;EACA,eAAA;ACkIJ;AA3IA;;EAuIQ,gBAAA;AAQR;AA/IA;;EA0IU,SAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;AASV;AAtJA;;EAiJU,aAAA;EACA,mBAAA;EACA,uBAAA;AASV;AA5JA;EAaM,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EAsIA,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;EACA,gBAAA;AAaN;AA3KA;EAiKM,eAAA;AAaN;AA9KA;;EAuKI,wBAAA;EACA,SAAA;AAWJ;AAnLA;EA8KI,eAAA;AAQJ;AAXI;EACE,qBAAA;AAaN;AAPA;EACE,WAAA;AASF;AANA;EACE,cAAA;EACA,mBAAA;AAQF;AALA;EACE,mBAAA;EACA,cAAA;AAOF;AATA;EAKI,mBAAA;EACA,kBAAA;AAOJ;AAbA;EASM,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AAON;AANM;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AAQR;AAzBA;EAoBQ,cAAA;EACA,YAAA;AAQR;AAFA;EACE,eAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAIF;AARA;EDpNI,cAAA;EACA,qBAAA;AC+NJ;AAZA;;ED/MI,cAAA;EACA,qBAAA;EACA,eAAA;AC+NJ;AAlBA;EAQI,kBAAA;AAaJ;AArBA;EAYI,WAAA;AAYJ;AAxBA;EAgBI,WAAA;AAWJ;AA3BA;EAoBI,iBAAA;AAUJ;AA9BA;EAwBI,cAAA;AASJ;AALA;EACE,mBAAA;AAOF;AARA;EAII,wBAAA;EACA,cAAA;AAOJ;AAHA;EAEI,cAAA;AAIJ;AANA;EAIM,cAAA;AAKN;AATA;;EAQM,cAAA;AAKN;AAAA;EACE,qBAAA;AAEF;AACA;EACE,eAAA;AACF;AAFA;;EAIM,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AAEN;AADM;;EACE,cAAA;EAIN,kDAAkD;EAH5C,UAAA;EAKN,iDAAiD;AACnD;AAjBA;EAgBI,eAAA;EACA,gBAAA;AAIJ;AAAA;;EAEI,0BAAA;EACA,2BAAA;AAEJ;AAEA;EACE,eAAA;EACA,cAAA;AAAF;AAFA;EAII,gBAAA;EACA,cAAA;AACJ;AAGA;EACE,aAAA;EACA,oBAAA;AADF;AAIA;;EACE,uBAAA;AADF;AAIA;;EAEI,gBAAA;AAFJ;AAMA;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AAJF;AAKE;EACE,cAAA;EAHF,kDAAkD;EAIhD,UAAA;EAFF,iDAAiD;AACnD","sourcesContent":["@import 'colors';\n\n@link-text-color: @ivory;\n@link-hover-color: @orange;\n\n@blue-link-text-color: @blue2;\n@blue-link-hover-color: @blue4;\n\n@border-radius: 3px;\n@large-border-radius: 10px;\n@z-index-high: 999;\n@z-index-modal: 1050;\n@issue-padding: 10px;\n@input-height: 2.5rem;\n@button-width: 125px;\n@button-height: 30px;\n@time-picker-input-width: 3.125rem;\n\n.link(@text-color: @link-text-color, @hover-color: @link-hover-color) {\n  a {\n    color: @text-color;\n    text-decoration: none;\n  }\n  a:hover,\n  a:focus {\n    color: @hover-color;\n    text-decoration: none;\n    cursor: pointer;\n  }\n}\n\n.link-underline(@text-color: @blue-link-text-color, @hover-color: @blue-link-hover-color, @decoration: underline) {\n  a {\n    color: @text-color;\n    text-decoration: @decoration;\n  }\n  a:hover,\n  a:focus {\n    color: @hover-color;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n}\n\n.horizontal-list(@padding: 15px) {\n  ul,\n  ol {\n    display: block;\n    margin-left: 0;\n  }\n  li {\n    display: inline;\n    list-style-type: none;\n    padding: @padding;\n\n    .link();\n  }\n  /* not ie8 compat.\n  li + li::before {\n    content: \" | \";\n  }\n  */\n}\n\n.spinner(@top: 0, @right: 0, @bottom: 0, @left: 0) {\n  position: fixed;\n  top: @top;\n  right: @right;\n  bottom: @bottom;\n  left: @left;\n  z-index: 1100;\n  background-color: @choc;\n  opacity: 0.7;\n  filter: alpha(opacity=70);\n  display: none; /* do not show by default */\n\n  .image {\n    background: url('@{asset-base-url}/images/spinner.gif') no-repeat;\n    background-size: 36px 36px;\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-left: -18px; /* -1 * image width / 2 */\n    margin-top: -18px; /* -1 * image height / 2 */\n    border: none;\n  }\n\n  .processing-msg {\n    color: @link-text-color;\n    text-align: center;\n    vertical-align: middle;\n    line-height: 60;\n  }\n}\n\n.fa-spin-custom,\n.glyphicon-spin {\n  -webkit-animation: spin 1000ms infinite linear;\n  animation: spin 1000ms infinite linear;\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n","@import 'colors';\n@import 'utility';\n\n@search-bg-color: @blue1;\n@search-title-text-color: @white;\n@search-form-header-bg-color: @tripB3;\n@search-form-body-bg-color: @tripB1;\n@search-form-accordion-link-color: @blue1;\n@search-form-accordion-link-hover-color: @white;\n@search-form-label-color: @white;\n@search-form-input-text-color: @white;\n@search-form-input-bg-color: @input;\n@search-form-input-border-color: @white;\n@search-form-input-valid: @green;\n@search-form-input-invalid: @red;\n@search-actions-text-color: @blue1;\n@search-actions-hover-text-color: @ivory;\n\n.search {\n  background: @search-bg-color;\n  padding: 5px 10px;\n\n  .row {\n    .col-md-12 {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n\n  .search-form {\n    .input-base {\n      padding: 5px 7px;\n      height: 2.5rem;\n      text-align: left;\n      display: block;\n      outline-width: 0;\n      color: @search-form-input-text-color;\n      background-color: @search-form-input-bg-color;\n      border: 1px solid @search-form-input-border-color;\n    }\n\n    select,\n    input {\n      .input-base;\n    }\n\n    input.hours-field,\n    input.minutes-field {\n      text-align: center;\n      min-width: 32px;\n    }\n\n    .waiver-selector select {\n      display: block;\n      outline-width: 0;\n      height: @input-height;\n    }\n\n    input::-webkit-input-placeholder,\n    input:-moz-placeholder,\n    input::-moz-placeholder,\n    input:-ms-input-placeholder {\n      color: @white;\n      font-style: italic;\n    }\n\n    label {\n      margin-top: 10px;\n      color: @search-form-label-color;\n    }\n\n    .ng-invalid.ng-dirty {\n      border-color: @search-form-input-invalid;\n      outline-color: @search-form-input-invalid;\n    }\n    .ng-valid.ng-dirty {\n      border-color: @search-form-input-valid;\n      outline-color: @search-form-input-valid;\n    }\n\n    .form-group-sep {\n      padding-top: 10px;\n    }\n\n    .input-group {\n      margin-bottom: 0;\n    }\n\n    .search-button {\n      text-align: right;\n\n      .form-group {\n        margin: 25px 0 0 25px;\n        .button-clear,\n        .button-action {\n          color: @white;\n          width: @button-width;\n          height: @button-height;\n          padding: 5px 35px;\n          border: 1px solid;\n        }\n\n        .button-clear {\n          background-color: @blue6;\n          border-color: @blue6;\n          margin-right: 10px;\n        }\n        .button-clear:hover {\n          background-color: @blue5;\n          border-color: @blue5;\n        }\n\n        .button-action {\n          background-color: @orange;\n          border-color: @orange;\n        }\n        .button-action:hover {\n          background-color: @blue6;\n          border-color: @blue6;\n        }\n      }\n    }\n\n    i.sprites.sprite-calendar-gray,\n    i.sprites.sprite-calendar-ivory {\n      display: block;\n      height: 20px;\n    }\n\n    div[uib-accordion],\n    div.uib-accordion {\n      margin-top: 0;\n      margin-bottom: 0;\n\n      .panel-heading {\n        background: @search-form-header-bg-color;\n        padding: 15px;\n        color: @search-form-accordion-link-color;\n\n        .panel-title {\n          margin: 0;\n          font-size: 14px;\n          i {\n            margin-right: 0.2em;\n          }\n          .link(\n            @search-form-accordion-link-color,\n            @search-form-accordion-link-hover-color\n          );\n        }\n      }\n\n      .panel-group {\n        margin-bottom: 0;\n\n        .panel {\n          border: 0;\n          border-radius: @large-border-radius;\n          -moz-border-radius: @large-border-radius;\n          -webkit-border-radius: @large-border-radius;\n        }\n\n        .panel-body {\n          border-top: 0;\n          background: @search-form-body-bg-color;\n          padding: 0 5px 15px 5px;\n        }\n      }\n    }\n\n    .trip-group-selector {\n      .input-base;\n      border-radius: @border-radius;\n      -moz-border-radius: @border-radius;\n      -webkit-border-radius: @border-radius;\n      height: 100px;\n      overflow-y: auto;\n    }\n    .trip-group-selector:hover {\n      cursor: pointer;\n    }\n  }\n\n  input[type='number']::-webkit-inner-spin-button,\n  input[type='number']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  .resolve-by {\n    &.resolve-by-date-selectors {\n      margin-bottom: 0.5rem;\n    }\n    padding-left: 0;\n  }\n}\n\n.uib-datepicker-popup {\n  color: #333;\n}\n\n.date-picker-label {\n  display: block;\n  font-weight: normal;\n}\n\n.date-picker-input {\n  vertical-align: top;\n  height: @input-height;\n\n  .input-group-btn {\n    vertical-align: top;\n    margin-right: 20px;\n\n    button {\n      vertical-align: top;\n      height: @input-height;\n      border-left: none;\n      background-color: @input;\n      border-color: @white;\n      &.ng-invalid.ng-dirty {\n        border-left: 0;\n        border-color: @search-form-input-invalid;\n        outline-color: @search-form-input-invalid;\n    }\n      .sprite-calendar-gray {\n        display: block;\n        height: 20px;\n      }\n    }\n  }\n}\n\n.timepicker {\n  padding-left: 0;\n  margin-right: 0;\n  margin-bottom: -20px;\n  margin-top: 15px;\n\n  .link(@search-actions-hover-text-color);\n  td {\n    padding-right: 5px;\n  }\n\n  .timepicker-field input {\n    width: 40px;\n  }\n\n  .uib-time input {\n    width: 40px;\n  }\n\n  .btn {\n    padding: 5px 10px;\n  }\n\n  .btn-link {\n    padding: 2px 0;\n  }\n}\n\n.search-title {\n  background: @search-bg-color;\n\n  .col-md-12 {\n    padding: 10px 0 5px 10px;\n    color: @search-title-text-color;\n  }\n}\n\n.search-actions {\n  .actions {\n    margin: 10px 0;\n    .btn {\n      color: @search-actions-text-color;\n    }\n    .btn:hover,\n    .btn:focus {\n      color: @search-actions-hover-text-color;\n    }\n  }\n}\n\n.month-select {\n  padding-right: 0.1rem;\n}\n\n.flight-search-datepicker {\n  display: inline;\n  .custom-date-picker-input {\n    input, .form-control {\n      background-color: #a8b0b8;\n      color: #ffffff;\n      border: 1px solid #ffffff;\n      border-right: 0;\n      height: @input-height;\n      &::placeholder {\n        color: #ffffff; /* Change this to your desired placeholder color */\n        opacity: 1; /* Ensure full opacity for the placeholder text */\n      }\n    }\n  }\n  .date-picker-wrapper{\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n.custom-date-picker-input {\n  input, .form-control {\n    border-right: 0 !important;\n    box-shadow: none !important;\n  }\n}\n\n.time-picker-width {\n  width: @time-picker-input-width;\n  height: @input-height;\n  .btn {\n    margin-left: 5px;\n    height: @input-height;\n  }\n}\n\n.waiver-reporting-form-button {\n  display: flex;\n  justify-content: end;\n}\n\n.month-select__single-value, .year-select__single-value {\n  margin-bottom: 0.625rem;\n}\n\n.flight-search-datepicker {\n  .month-select__single-value, .year-select__single-value {\n    margin-bottom: 0;\n  }\n}\n\n.date-range-picker-input {\n  background-color: #a8b0b8;\n  color: #ffffff;\n  border: 1px solid #ffffff;\n  border-right: 0;\n  height: @input-height;\n  &::placeholder {\n    color: #ffffff; /* Change this to your desired placeholder color */\n    opacity: 1; /* Ensure full opacity for the placeholder text */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
